import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {AppState} from '../../../shared/store/store';
import {Store} from '@ngrx/store';
import {combineLatest, Observable} from 'rxjs';
import {FolderComponentObject, FolderComponentObjects} from '../../../shared/classes/folder-component-object';
import {selectFolderComponentObjects} from '../../../shared/store/savedReportsFolders/savedReportsFolders.selectors';
import {SavedReportComponentObject, SavedReportComponentObjects} from '../../../shared/classes/saved-report-component-object';
import {selectSavedReportComponentObjects} from '../../../shared/store/savedReports/savedReports.selectors';
import {map} from 'rxjs/operators';
import {Sort} from '../../../shared/libraries/sort';
import {enterLeaveOpacityAnimation, enterOpacityAnimation, showOpacityAnimation} from '../../../shared/animations/show-opacity.animation';

@Component({
  selector: 'app-search-results',
  templateUrl: './search-results.component.html',
  styleUrls: ['./search-results.component.scss'],
  host: {'class': 'adloop-scrollbar'},
  animations: [
    enterOpacityAnimation
  ]
})
export class SearchResultsComponent {
  @Input() public value: string;

  @Output() public onFilter: EventEmitter<FolderComponentObject | SavedReportComponentObject> = new EventEmitter<FolderComponentObject | SavedReportComponentObject>();
  @Output() public onOpen: EventEmitter<FolderComponentObject | SavedReportComponentObject> = new EventEmitter<FolderComponentObject | SavedReportComponentObject>();

  @HostBinding('@enterOpacity') animate: boolean = true;

  public readonly folders$: Observable<FolderComponentObjects> = this._store.select(selectFolderComponentObjects);
  public readonly reports$: Observable<SavedReportComponentObjects> = this._store.select(selectSavedReportComponentObjects);

  public readonly items$: Observable<Array<FolderComponentObject | SavedReportComponentObject>> = combineLatest([
    this.folders$,
    this.reports$
  ]).pipe(
    map(([folders, reports]): Array<FolderComponentObject | SavedReportComponentObject> => {
      return [
        ...folders,
        ...reports
      ].sort((a: FolderComponentObject | SavedReportComponentObject, b: FolderComponentObject | SavedReportComponentObject) => Sort.alphaAsc(a.payload.attributes.name, b.payload.attributes.name));
    })
  );

  constructor(
    private readonly _store: Store<AppState>
  ) {
  }

}
